import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from './IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import SelectWrapped from './SelectWrapped'
import * as API from '../api'
import { buildExternalHtmlLink, buildInternalHtmlLink } from '../utils/htmlLinkUtils'

const buildInitialState = props => {
  const initial = props.initial || {}
  const contentId = initial.contentId || ''

  return {
    type: initial.type || 'external',
    text: initial.text || '',
    url: initial.url || '',
    content: contentId
      ? { value: contentId, label: initial.contentLabel || initial.text || contentId }
      : null,
    error: '',
  }
}

class HtmlLinkDialog extends Component {
  constructor(props) {
    super(props)
    this.state = buildInitialState(props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && (!this.props.open || nextProps.initial !== this.props.initial)) {
      this.setState(buildInitialState(nextProps))
    }
  }

  handleApply = () => {
    const { type, text, url, content } = this.state

    try {
      const html =
        type === 'internal'
          ? buildInternalHtmlLink(text, (content || {}).value)
          : buildExternalHtmlLink(text, url)

      this.props.onApply(html)
    } catch (error) {
      this.setState({ error: error.message })
    }
  }

  render() {
    const { open, onClose, modalId = 'editor-html-link' } = this.props
    const { type, text, url, content, error } = this.state

    return (
      <Dialog
        modalId={modalId}
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id={modalId + '-title'}>Editor HTML — Inserir ou editar link</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <Button
              size="small"
              color="primary"
              variant={type === 'external' ? 'contained' : 'outlined'}
              onClick={() => this.setState({ type: 'external', error: '' })}
            >
              URL externa
            </Button>
            <Button
              size="small"
              color="primary"
              variant={type === 'internal' ? 'contained' : 'outlined'}
              onClick={() => this.setState({ type: 'internal', error: '' })}
            >
              Conteúdo do Informed
            </Button>
          </div>

          <TextField
            fullWidth
            label="Texto que aparecerá no link"
            value={text}
            onChange={event => this.setState({ text: event.target.value, error: '' })}
            margin="normal"
          />

          {type === 'external' ? (
            <TextField
              fullWidth
              label="URL de destino"
              placeholder="https://exemplo.com.br/pagina"
              value={url}
              onChange={event => this.setState({ url: event.target.value, error: '' })}
              margin="normal"
            />
          ) : (
            <TextField
              fullWidth
              label="Pesquisar conteúdo no Informed"
              value={content}
              onChange={selected =>
                this.setState(prev => ({
                  content: selected,
                  text: prev.text || ((selected || {}).label || ''),
                  error: '',
                }))
              }
              placeholder="Digite o título do conteúdo..."
              margin="normal"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                inputComponent: SelectWrapped,
                inputProps: {
                  multi: false,
                  instanceId: modalId + '-content-select',
                  id: modalId + '-content-select',
                  loadOptions: API.content.getSelectContents(''),
                },
              }}
            />
          )}

          {error ? <Typography color="error">{error}</Typography> : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button color="primary" variant="contained" onClick={this.handleApply}>
            Aplicar link
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default HtmlLinkDialog




// WEBPACK FOOTER //
// ./src/components/HtmlLinkDialog.js